var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{class:[("header__" + (_vm.changeHgLogo ? 'hgConnectLogo' : 'logo'))]})])}
var staticRenderFns = []

export { render, staticRenderFns }